import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { filter, map, take } from 'rxjs/operators';
import { WorkspaceService } from '@sentry/forms-core';

export const workspaceGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const workspaceService = inject(WorkspaceService);
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isLoading$.pipe(
    filter((loading) => !loading),
    take(1),
    map(() => {
      if (workspaceService.activeWorkspace() && workspaceService.currentUser()) {
        return true;
      }
      const qIdx = state.url.indexOf('?');
      const locationId = qIdx >= 0
        ? new URLSearchParams(state.url.slice(qIdx + 1)).get('location')
        : null;
      return router.createUrlTree(['/select-workspace'], {
        queryParams: { returnTo: state.url, ...(locationId ? { location: locationId } : {}) },
      });
    }),
  );
};
